import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

// import { Actualite } from '../shared';
import { ActualiteService, ContextService } from '../../shared';

@Component({
  selector: 'app-actualite-detail',
  templateUrl: './actualite-detail.component.html',
  styleUrls: ['./actualite-detail.component.scss']
})
export class ActualiteDetailComponent implements OnInit {
  
  actualite: any = {};
  list: any = [];
  context_route:string;
  loading: boolean = true;
  context:string= '';

  constructor(
  	private route: ActivatedRoute,
  	private router: Router,
    private actualiteService: ActualiteService,
    private contextService: ContextService,

  ) {
      window.scrollTo(0, 0);

    }

  ngOnInit(): void {
    this.context = this.contextService.getContext();
    if(this.context == 'B2C') this.context_route = '/familles';
  	this.getActualite();


       this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
           window.scrollTo(0, 0);
           this.loading=true;
           this.getActualite();
        }
          
     });









  }

  getActualite(): void {
  	const slug = this.route.snapshot.paramMap.get('slug')+'/';
  	this.actualiteService.getSingleActualite(slug)
  	  .subscribe(data => {

        this.actualite = data.detail;
        this.list = data.actu;
        this.loading = false;
             console.log(this.list)
      });
      // console.log(this.actualite);
  }





}



// WEBPACK FOOTER //
// ./src/app/actualite/_detail/actualite-detail.component.ts